import React from 'react'
import { FormattedMessage } from 'react-intl'

export const QVMDirectoryHeader = () => (
  <>
    <div className="mb-2 text-foreground my-body-md">
      <FormattedMessage defaultMessage="WELCOME TO QV MELBOURNE" id="oBcDFE" />
    </div>
    <p className="mb-4 my-heading-2xl">
      <FormattedMessage defaultMessage="Hungry?" id="LwsigP" />
      <br />
      <FormattedMessage defaultMessage="Order/Ahead" id="6IHYTs" />
    </p>
    <p className="mb-6 flex justify-center my-label-md">
      <FormattedMessage
        defaultMessage="Order a selection of food &amp; drinks online."
        id="UdZhqV"
      />
    </p>
  </>
)
